import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class JumpAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const top = item.y - 150;
        const bottom = item.y;
        const duration = this.time || 0.6;
        const s = item.scale.y;
        item.tweenTo(duration * 0.15, Ease.sineInOut, {
            scaleY: s * 0.9,
            delay: this.delay,
            repeat: 1,
            yoyo: true,
            onUpdate: () => this.updatePaperCut(item),
            onComplete: () => {
                item.tweenTo(duration * 0.3, Ease.circOut, {
                    y: top,
                    scaleY: s * 1.1,
                    onUpdate: () => this.updatePaperCut(item),
                    onComplete: () => {
                        item.tweenTo(duration * 0.1, Ease.sineIn, {
                            y: bottom,
                            scaleY: s,
                            onUpdate: () => this.updatePaperCut(item),
                            onComplete: () => {
                                item.tweenTo(duration * 0.15, Ease.sineInOut, {
                                    scaleY: s * 0.9,
                                    repeat: 1,
                                    yoyo: true,
                                    onUpdate: () => this.updatePaperCut(item),
                                    onComplete: () => {
                                        this.onComplete();
                                        cb();
                                    },
                                });
                            },
                        });
                    },
                });
            },
        });
    }
}
